import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { UserService } from "@services/user.service";
import { SchoolService } from "@services/school.service";
import { Router } from "@angular/router";
import { NotificationsService } from "@services/notifications.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  oldPw: String;
  newPw: String;
  confirmPw: String;
  policies;
  passwordStrength: number = 0;

  COGNITO_SPECAIL_CHARACTER_REGEX =
    "[\\^ $ * . [ \\] { } ( ) ? \\- \" ! @ # % & / \\\\ , > < ' : ; | _ ~ `]";

  constructor(
    private notification: NotificationsService,
    private userService: UserService,
    public location: Location,
    private router: Router,
    private school: SchoolService
  ) {}
  public isLoading: boolean = true;

  ngOnInit() {
    this.userService.getPasswordPolicy().subscribe(
      (data) => {
        this.isLoading = false;
        this.policies = data;
      },
      (err) => {
        this.isLoading = false;
        // Unable to retrieve pw policy at this time
      }
    );
  }

  resetPw() {
    this.userService.changePassword(this.oldPw, this.newPw).subscribe(
      (result) => {
        if (result.status === "password reset") {
          this.notification.popNotification("", "Updated Password");
          this.router.navigate(["/home"]);
        } else {
          const errorMessage =
            result?.error === "LimitExceededException"
              ? "Too many attempts at this time."
              : result?.error === "LimitExceededException"
              ? "NotAuthorizedException."
              : "Error Updating Password.";
          this.notification.popNotification("", errorMessage);
        }
      },
      (err) => console.log(err),
      () => console.log("done with pw reset")
    );
  }
}
